import React from 'react';
import styled from 'styled-components';
import { Paragraph } from './Text';

const StyledProgressBarContainer = styled.div`
width: 100%;
height: 20px;
position: relative;
background: #FFFFFF;
border-radius: 100px;
`;

const StyledProgressBar = styled.div`
height: 20px;
background: var(--sp-success-color);
width: ${({progress}) => progress}%;
border-radius: ${({progress}) => `100px ${progress < 99 ? "0px" : "100px"} ${progress < 99 ? "0px" : "100px"} 100px`};

animation: ${({processing}) => processing ? "glowing 1300ms infinite" : "none" };

@keyframes glowing {
    0% { background-color: var(--sp-success-color); box-shadow: 0 0 2px var(--sp-success-color); }
    50% { background-color: #49e819; box-shadow: 0 0 5px #49e819; }
    100% { background-color: var(--sp-success-color); box-shadow: 0 0 2px var(--sp-success-color); }
}
`;

const StyledProgressText = styled(Paragraph).attrs({
fontWeight: 600,
lineHeight: "20px"
})`
position: absolute;
top: 0;
right: 45%;
color: ${({progress}) => progress > 55 ? "#FFFFFF" : null};
`;

export const ProgressBar = ({ progress, status, ...props}) => (
<StyledProgressBarContainer>
    <StyledProgressBar progress={progress} processing={status == 3}/>
    <StyledProgressText progress={progress}>{progress}%</StyledProgressText>
</StyledProgressBarContainer>
);